import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import api from '../../api/axios';

const ReservaFormModal = ({ show, onClose, onSuccess }) => {
  const business = JSON.parse(localStorage.getItem('business'));

  const [form, setForm] = useState({
    nombre_cliente: '',
    fecha: '',
    hora: '',
    personas: 1,
    telefono: '',
    estado: 'pendiente',
    notas: '',
    mesas: []
  });

  const [mesasDisponibles, setMesasDisponibles] = useState([]);

  useEffect(() => {
    if (show && business?.id) {
      api.get(`/tables?business_id=${business.id}`)
        .then(res => setMesasDisponibles(res.data))
        .catch(err => console.error('Error al traer mesas:', err));
    }
  }, [show, business]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const toggleMesa = (mesaId) => {
    setForm(prev => {
      const already = prev.mesas.includes(mesaId);
      const mesas = already
        ? prev.mesas.filter(id => id !== mesaId)
        : [...prev.mesas, mesaId];
      return { ...prev, mesas };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/reservas', form);

      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error al crear reserva:', err);
      alert('No se pudo crear la reserva');
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>➕ Crear Reserva</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-2">
            <Form.Label>Nombre del cliente</Form.Label>
            <Form.Control
              type="text"
              name="nombre_cliente"
              value={form.nombre_cliente}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Row>
            <Col>
              <Form.Group className="mb-2">
                <Form.Label>Fecha</Form.Label>
                <Form.Control
                  type="date"
                  name="fecha"
                  value={form.fecha}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-2">
                <Form.Label>Hora</Form.Label>
                <Form.Control
                  type="time"
                  name="hora"
                  value={form.hora}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-2">
            <Form.Label>Personas</Form.Label>
            <Form.Control
              type="number"
              name="personas"
              value={form.personas}
              min={1}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Teléfono</Form.Label>
            <Form.Control
              type="text"
              name="telefono"
              value={form.telefono}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Estado</Form.Label>
            <Form.Select name="estado" value={form.estado} onChange={handleChange}>
              <option value="pendiente">Pendiente</option>
              <option value="confirmada">Confirmada</option>
              <option value="cancelada">Cancelada</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Notas</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="notas"
              value={form.notas}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Seleccionar mesas</Form.Label>
            <div className="d-flex flex-wrap gap-2">
              {mesasDisponibles.map((mesa) => (
                <Form.Check
                  key={mesa.id}
                  type="checkbox"
                  label={mesa.name}
                  value={mesa.id}
                  checked={form.mesas.includes(mesa.id)}
                  onChange={() => toggleMesa(mesa.id)}
                />
              ))}
            </div>
          </Form.Group>

          <div className="d-flex justify-content-end">
            <Button variant="secondary" onClick={onClose} className="me-2">
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              Guardar Reserva
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ReservaFormModal;
